import { createWebSocketStore } from 'src/components/#services/helpers';
export const getAllSessions = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'auth',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'authJournal_getAllMy',
    },
});
export const logoutEverything = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'auth',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'logout_logoutEverything',
    },
});
